import type { RouteRecordRaw } from 'vue-router'

// Routes of the map area. The map itself is public; spot details, images and questions are checked by the server per request.
// Province and spot routes open the same screen with that province or spot selected.
export const routes: RouteRecordRaw[] = [
  { path: '/map', name: 'map', component: () => import('./MapView.vue') },
  { path: '/map/:province', name: 'map-province', component: () => import('./MapView.vue'), props: true },
  { path: '/map/:province/:spot', name: 'map-spot', component: () => import('./MapView.vue'), props: true },
]
